export const mockRequestQuoteValues = {
  salutation: "male",
  firstName: "John",
  lastName: "Doe",
  email: "john.doe@example.com",
  phone: "+49123456789",
  company: "Asecos GmbH",
  country: "Germany",
  postalCode: "63584",
  city: "Gründau",
  street: "Weiherfeldsiedlung",
  number: "16-18",
  contactHours: {
    morning: true,
    afternoon: true,
  },
  comment: "I would like to request a quote for safety cabinets.",
};
